import { COMMON_TIMEZONES } from '../../utils/timezone';
import Select from '../UI/Select';

const CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR - Euro (€)' },
  { value: 'GBP', label: 'GBP - British Pound (£)' },
  { value: 'USD', label: 'USD - US Dollar ($)' },
];

const TIMEZONE_OPTIONS = COMMON_TIMEZONES.map(tz => ({
  value: tz.value,
  label: tz.label,
}));

/**
 * PreferencesCard - Home timezone and base currency settings
 */
export default function PreferencesCard({
  preferences,
  onPreferencesChange,
  onSave,
  saving,
  isOnline,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Preferences</h3>
      </div>
      <div className="card-body space-y-4">
        {!isOnline && (
          <div 
            className="p-3 rounded-sm text-sm"
            style={{ 
              backgroundColor: 'rgba(193, 96, 92, 0.1)',
              color: 'var(--color-status-error)',
            }}
          >
            Preferences cannot be changed while offline. Please reconnect to update your settings.
          </div>
        )}
        
        <div>
          <label className="label">Home Timezone</label>
          <p className="text-sm mb-2" style={{ color: 'var(--color-text-muted)' }}>
            Your home timezone is used to display times in both local and home time on the calendar.
          </p>
          <Select
            options={TIMEZONE_OPTIONS}
            value={preferences.home_timezone}
            onChange={(value) => onPreferencesChange({ ...preferences, home_timezone: value })}
            disabled={!isOnline}
          />
        </div>

        <div>
          <label className="label">Base Currency</label>
          <p className="text-sm mb-2" style={{ color: 'var(--color-text-muted)' }}>
            Your base currency for budget tracking and expense totals.
          </p>
          <Select
            options={CURRENCY_OPTIONS}
            value={preferences.base_currency}
            onChange={(value) => onPreferencesChange({ ...preferences, base_currency: value })}
            disabled={!isOnline}
          />
        </div>

        <button
          onClick={onSave}
          disabled={saving || !isOnline}
          className="btn-primary"
        >
          {saving ? 'Saving...' : 'Save Preferences'}
        </button>
      </div>
    </div>
  );
}
